export const checkinList = {
  group: {
    sectionTitle: "Check-ins associés",
    registrationForm: "Fiche de police",
    registrationFormHint: "Un seul document avec le titulaire et ses accompagnants",
    registrationFormEmpty: "Aucun check-in n'a encore été effectué pour cette réservation.",
    registrationFormError: "La fiche n'a pas pu être générée. Réessaie.",
    emptyState: "Aucun check-in associé.",
    name: "Nom",
    phone: "Téléphone",
    document: "Document",
    notAvailable: "Non disponible",
    syncSent: "Envoyé à l'immigration",
    syncError: "Erreur d'immigration",
    syncPending: "Envoi en attente",
    moreInfo: "Plus d'informations",
    email: "E-mail",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Type de document",
    supportNumber: "Numéro de support",
    documentBack: "Verso",
    identityNoMatch: "Les visages ne correspondent pas",
    identityStored: "Sans comparaison faciale",
    identityError: "Comparaison impossible",
    identityNoPhotos: "Dans ce pays, les photos ne sont pas conservées : seul le résultat demeure.",
    identityVerification: "Vérification d'identité",
    tapToEnlarge: "Appuyez pour agrandir",
    view: "Voir",
    download: "Télécharger",
    selfie: "Selfie",
    minorData: "Détails du mineur",
    relationship: "Lien de parenté :",
    noPhotos: "Aucune photo jointe.",
    minorDocument: "Document du mineur",
    authorization: "Autorisation",
    minorAuthorization: "Autorisation du mineur",
    specification: "Précision :",
    additionalInfo: "Informations complémentaires",
    nationality: "Nationalité",
    birthDate: "Date de naissance",
    ageYears: "({age} ans)",
    gender: "Sexe",
    female: "Femme",
    male: "Homme",
    countryResidence: "Pays de résidence",
    cityResidence: "Ville de résidence",
    address: "Adresse",
    zipCode: "Code postal",
    sesBatchId: "ID de lot SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Pays de naissance",
    docIssuePlace: "Lieu de délivrance du document",
    signedDocument: "Document signé",
    edit: "Modifier",
    remove: "Supprimer",
    previewAlt: "Aperçu",
    previewFallbackTitle: "Image",
    docTypes: {
      passport: "Passeport",
      passportOrdinary: "Passeport ordinaire",
      passportService: "Passeport de service",
      passportDiplomatic: "Passeport diplomatique",
      idCard: "Carte d'identité",
      nie: "NIE",
      idCardElectronic: "Carte d'identité électronique",
      idDiplomatic: "Document d'identité diplomatique",
      citizenshipCard: "Carte de citoyenneté",
      foreignerCard: "Carte d'identité d'étranger",
      drivingLicense: "Permis de conduire",
      nauticalLicense: "Permis bateau",
      specialResidencePermit: "Titre de séjour spécial",
      foreignerDocument: "Document d'étranger",
      foreignDocument: "Document étranger",
      diplomaticCard: "Carte diplomatique",
      refugeeTravelDocument: "Titre de voyage pour réfugié",
      otherDocument: "Autre document",
    },
  },
  individual: {
    title: "Détails du client",
    phone: "Téléphone",
    email: "E-mail",
    notAvailable: "Non disponible",
    lodging: "Séjour",
    docType: "Type de document",
    docNumber: "Numéro de document",
    supportNumber: "Numéro de support",
    identityVerification: "Vérification d'identité",
    document: "Document",
    tapToEnlarge: "Appuyez pour agrandir",
    view: "Voir",
    download: "Télécharger",
    selfie: "Selfie",
    minorData: "Détails du mineur",
    relationship: "Lien de parenté :",
    noPhotos: "Aucune photo jointe.",
    minorDocument: "Document du mineur",
    authorization: "Autorisation",
    minorAuthorization: "Autorisation du mineur",
    specification: "Précision :",
    additionalInfo: "Informations complémentaires",
    nationality: "Nationalité",
    birthDate: "Date de naissance",
    ageYears: "({age} ans)",
    gender: "Sexe",
    female: "Femme",
    male: "Homme",
    countryResidence: "Pays de résidence",
    cityResidence: "Ville de résidence",
    address: "Adresse",
    zipCode: "Code postal",
    sesBatchId: "ID de lot SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Pays de naissance",
    docIssuePlace: "Lieu de délivrance du document",
    signedDocument: "Document signé",
    edit: "Modifier",
    previewAlt: "Aperçu",
    previewFallbackTitle: "Image",
    docTypes: {
      passport: "Passeport",
      passportOrdinary: "Passeport ordinaire",
      passportService: "Passeport de service",
      passportDiplomatic: "Passeport diplomatique",
      idCard: "Carte d'identité",
      nie: "NIE",
      idCardElectronic: "Carte d'identité électronique",
      idDiplomatic: "Document d'identité diplomatique",
      citizenshipCard: "Carte de citoyenneté",
      foreignerCard: "Carte d'identité d'étranger",
      drivingLicense: "Permis de conduire",
      nauticalLicense: "Permis bateau",
      specialResidencePermit: "Titre de séjour spécial",
      foreignerDocument: "Document d'étranger",
      foreignDocument: "Document étranger",
      diplomaticCard: "Carte diplomatique",
      refugeeTravelDocument: "Titre de voyage pour réfugié",
      otherDocument: "Autre document",
    },
  },
};
